import { datadogRum } from "@datadog/browser-rum";

import React from "react";
import * as ReactDOM from "react-dom";
import { RouterProvider } from "react-router-dom";

import config from "../config";
import getRouter from "./router";
import { LegacyRedirect } from "./features/legacyRedirects/components/legacyRedirect";

import "./styles/styles.scss";

datadogRum.init({
  ...config.datadog,
  version: process.env.APP_VERSION,
});
datadogRum.startSessionReplayRecording();

const domContainer = document.querySelector("#app");
ReactDOM.render(
  <>
    <RouterProvider router={getRouter()} />
    <LegacyRedirect />
  </>,
  domContainer
);
